import {
  disabledFalse,
  disabledTrue,
  hiddenFilter,
  hiddenTrue,
  PORTFOLIOS,
} from "../../constants";

export const METADATA_PRODUCTO = [
  {
    label: "Producto",
    id: "product",
    collapsable: true,
    metadata: [
      {
        label: "Nombre Comercial",
        name: "tradeName",
        type: "textarea",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Importe",
        name: "price",
        type: "text",
        numberSeparator: true,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        addon: "€",
      },
      {
        label: "Importe Mín.",
        name: "minimalPrice",
        type: "text",
        numberSeparator: true,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        addon: "€",
      },
      {
        label: "PVP Mínimo Aprobado BX",
        name: "isBxMinimalPriceApproved",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Importe CRM",
        name: "crmPrice",
        type: "text",
        numberSeparator: true,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        addon: "€",
      },
      {
        label: "Importe Mín. CRM",
        name: "minimalCrmPrice",
        type: "text",
        numberSeparator: true,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        addon: "€",
      },
      {
        label: "Precio alquiler",
        name: "rentalPrice",
        type: "text",
        numberSeparator: true,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        addon: "€",
        min: 0,
        visibleFor: [PORTFOLIOS.SAREB, PORTFOLIOS.QUASAR, PORTFOLIOS.ANTICIPA],
      },
      {
        label: "Precio alquiler web",
        name: "rentalPriceWeb",
        type: "text",
        numberSeparator: true,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        addon: "€",
        min: 0,
        visibleFor: [PORTFOLIOS.ANTICIPA],
      },
      {
        label: "Precio alquiler Web CRM",
        name: "rentalPriceCrm",
        type: "text",
        numberSeparator: true,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        addon: "€",
        min: 0,
        visibleFor: [PORTFOLIOS.ANTICIPA],
      },
      {
        label: "Api asignado",
        name: "isApiAssigned",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Publicado",
        name: "isPublishable",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Venta online",
        name: "onlineSale",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Venta Online Exclusiva",
        name: "webBookingAvailable",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "URL Venta online exclusiva",
        name: "webBookingAvailableURL",
        type: "text",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Cita virtual",
        name: "virtualDate",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Cálculo Precio web a consultar",
        name: "manualHidePvPAPICRM",
        type: "list",
        typeList: "Normal",
        listName: "hidePVP",
        propertyId: "Id",
        propertyName: "name",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Precio web a consultar",
        name: "hidePvPAPICRM",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Bloqueo Comercial",
        name: "isBlocked",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Motivo del bloqueo",
        name: "reasonBlock",
        type: "list",
        typeList: "Normal",
        listName: "reasonBlockList",
        propertyId: "Id",
        propertyName: "translation",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        required: false,
      },
      {
        label: "Referencia Negocio Fácil",
        name: "easyReferenceBusiness",
        type: "text",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Estado del producto",
        name: "status",
        type: "textFromList",
        typeList: "Normal",
        listName: "productStatus",
        propertyList: "translation",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Disponible",
        name: "isAvailable",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Forzado",
        name: "isForced",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Comentarios del Estado",
        name: "comments",
        type: "textarea",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Id Web Terciario",
        name: "terciaryWebId",
        type: "text",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Check GIAI",
        name: "checkGiai",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Alquiler",
        name: "rental",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "m² Superficie total",
        name: "builtM2Product",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "m² publicables",
        name: "areaPublishable",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        tooltip:
          "La superficie publicable es el resultado de un algoritmo acordado con BX y Anticipa que se basa en la superficie construida de catastro, pudiendo repercutir en algunos casos zonas comunes. En general no coincide con la superficie que aparece en la nota simple.",
      },
      {
        label: "Número de garajes",
        name: "garagesAmount",
        type: "number",
        min: 0,
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Número de trasteros",
        name: "storagesAmount",
        type: "number",
        min: 0,
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Susceptible BTS",
        name: "bts",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Posesion",
        name: "posesion",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        visibleFor: [PORTFOLIOS.SAREB, PORTFOLIOS.QUASAR, PORTFOLIOS.ANTICIPA],
      }
    ],
  },
  {
    label: "Quasar",
    id: "quasar",
    collapsable: true,
    metadata: [
      {
        label: "Ignorar validez precio mínimo",
        name: "ignoreMinimalPriceValidation",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
    ],
  },
  {
    label: "Sareb",
    id: "sareb",
    collapsable: true,
    visibleFor: [PORTFOLIOS.SAREB],
    metadata: [
      {
        label: "En proceso de transparencia",
        name: "inSarebCompetitiveProcess",
        type: "checkbox",
        class: "inline-block",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Inicio proceso de transparencia",
        name: "sarebCompetitiveStartDate",
        type: "date",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Fin proceso de transparencia",
        name: "sarebCompetitiveEndDate",
        type: "date",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Observaciones PT Sareb",
        name: "sarebPcComments",
        type: "textarea",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
    ],
  },
  {
    label: "Anticipa",
    id: "anticipa",
    collapsable: true,
    metadata: [
      {
        label: "ID Oportunidad",
        name: "currentOpId",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Fecha de ingreso",
        name: "currentOpDate",
        type: "date",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
    ],
  },
  {
    label: "Imágenes",
    id: "images",
    collapsable: true,
    metadata: [
      {
        label: "Imágenes",
        name: "urlImages",
        type: "carousel",
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Número de fotos",
        name: "defaultAssetPhotosNumber",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Letras de las fotos",
        name: "defaultAssetPhotoLetters",
        type: "textarea",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Fecha modificación fotos",
        name: "lastPhotosModificationDate",
        type: "date",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
    ],
  },
  {
    label: "Interés comercial",
    id: "commercialInterest",
    collapsable: true,
    metadata: [
      {
        label: "Interés comercial",
        name: "commercialInterestScore",
        type: "list",
        typeList: "Normal",
        listName: "commercialInterestScore",
        propertyId: "Id",
        propertyName: "name",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Valoración comercial",
        name: "commercialInterestDescription",
        type: "text",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
    ],
  },
  {
    label: "Suelo",
    id: "floor",
    collapsable: true,
    metadata: [
      {
        label: "Segmentación",
        name: "segmentation",
        type: "segmentation",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
    ],
  },
  {
    label: "Auditoría",
    id: "audit",
    collapsable: true,
    metadata: [
      {
        label: "Fecha Creación",
        name: "creationTime",
        type: "dateText",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Usuario Creación",
        name: "creatorId",
        type: "textFromList",
        typeList: "Normal",
        listName: "users",
        propertyList: "name",
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Fecha Última Modificación",
        name: "lastModificationTime",
        type: "dateText",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Usuario Modificación",
        name: "lastModifierId",
        type: "textFromList",
        typeList: "Normal",
        listName: "users",
        propertyList: "name",
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Fecha Borrado",
        name: "deletionTime",
        type: "dateText",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Usuario Borrado",
        name: "deleterId",
        type: "textFromList",
        typeList: "Normal",
        listName: "users",
        propertyList: "name",
        hidden: hiddenFilter,
        languageSensitive: false,
      },
    ],
  },
];

export const METADATA_NPL = [
  {
    label: "NPL",
    id: "npl",
    collapsable: true,
    metadata: [
      {
        label: "Id de NPL",
        name: "nplId",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Código de producto",
        name: "code",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Nombre Comercial",
        name: "tradeName",
        type: "textarea",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Descripción ",
        name: "tradeDescription",
        type: "text",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Publicado",
        name: "isPublishable",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Disponible",
        name: "isAvailable",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Bloqueo Comercial",
        name: "isBlocked",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Motivo del bloqueo",
        name: "reasonBlock",
        type: "list",
        typeList: "Normal",
        listName: "reasonBlockList",
        propertyId: "Id",
        propertyName: "translation",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        required: false,
      },
      {
        label: "Forzado",
        name: "isForced",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Cálculo Precio web a consultar",
        name: "manualHidePvPAPICRM",
        type: "list",
        typeList: "Normal",
        listName: "hidePVP",
        propertyId: "Id",
        propertyName: "name",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Precio web a consultar",
        name: "hidePvPAPICRM",
        type: "checkbox",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Estado del NPL",
        name: "status",
        type: "textFromList",
        typeList: "Normal",
        listName: "productStatus",
        propertyList: "translation",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "m² publicables",
        name: "areaPublishable",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenTrue,
        languageSensitive: false,
        tooltip:
          "La superficie publicable es el resultado de un algoritmo acordado con BX y Anticipa que se basa en la superficie construida de catastro, pudiendo repercutir en algunos casos zonas comunes. En general no coincide con la superficie que aparece en la nota simple.",
      },
      {
        label: "Comentarios del Estado",
        name: "comments",
        type: "textarea",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Deuda aproximada (€)",
        name: "debt",
        type: "text",
        numberSeparator: true,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        addon: "€",
        min: 0,
      },
      {
        label: "Bucket",
        name: "bucket",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Estrategia más reciente",
        name: "lastStrategy",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Valor de tasación original de subasta",
        name: "originalAppraisal",
        type: "number",
        min: 0,
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Cartera",
        name: "subPortfolio",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Motivo Cancelación (AMT)",
        name: "cancelReason",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Susceptible BTS",
        name: "bts",
        type: "checkbox",
        disabled: disabledFalse,
        hidden: hiddenFilter,
        languageSensitive: false,
      },
      {
        label: "Agrupación OSS",
        name: "btsGroup",
        type: "text",
        disabled: disabledTrue,
        hidden: hiddenFilter,
        languageSensitive: false,
        visibleFor: [PORTFOLIOS.NPL_TERCEROS],
      },
    ],
  },
  METADATA_PRODUCTO.find((e) => e.id === "audit"),
];

export const METADATA_NPL_FIELDS_TO_UPDATE = [
  { field: "id", type: "text" },
  { field: "tradeName", type: "text" },
  { field: "tradeDescription", type: "text" },
  { field: "manualHidePvPAPICRM", type: "triState" },
  { field: "isBlocked", type: "boolean" },
  { field: "reasonBlock", type: "number" },
  { field: "isForced", type: "boolean" },
  { field: "bts", type: "boolean" },
];

export const buildFormDataEditProduct = (data) => {
  let formData = {};
  formData.id = data.id;
  formData.delegationId = data.delegationId;
  formData.tradeName = data.tradeName || null;
  if (
    data.manualHidePvPAPICRM === "true" ||
    data.manualHidePvPAPICRM === true
  ) {
    formData.manualHidePvPAPICRM = true;
  } else if (
    data.manualHidePvPAPICRM === "false" ||
    data.manualHidePvPAPICRM === false
  ) {
    formData.manualHidePvPAPICRM = false;
  } else {
    formData.manualHidePvPAPICRM = null;
  }
  formData.isBlocked = data.isBlocked;
  if (!data.reasonBlock && data.reasonBlock !== 0) {
    formData.reasonBlock = null;
  } else {
    formData.reasonBlock = Number(data.reasonBlock);
  }
  formData.easyReferenceBusiness = data.easyReferenceBusiness || null;
  formData.isForced = data.isForced;
  formData.terciaryWebId = data.terciaryWebId || null;
  formData.checkGiai = data.checkGiai;
  formData.rental = data.rental;
  formData.garagesAmount = Number(data.garagesAmount) || 0;
  formData.storagesAmount = Number(data.storagesAmount) || 0;
  formData.bts = data.bts;
  formData.commercialInterestDescription =
    data.commercialInterestDescription || null;
  formData.commercialInterestScore = Number(data.commercialInterestScore) || 0;
  formData.segmentationPrimary = data.segmentationPrimary || null;
  formData.segmentationSecondary = data.segmentationSecondary || null;
  formData.segmentationPrimaryType = data.segmentationPrimaryType || null;
  formData.segmentationSecondaryType = data.segmentationSecondaryType || null;
  formData.webBookingAvailable = data.webBookingAvailable;
  formData.webBookingAvailableURL = data.webBookingAvailableURL || null;
  formData.ignoreMinimalPriceValidation = data.ignoreMinimalPriceValidation;
  formData.inSarebCompetitiveProcess = data.inSarebCompetitiveProcess;
  formData.espCondCode = data.espCondCode || "";
  return formData;
};

export const buildFormDataEditProductParticular = (data) => {
  let formData = {};
  formData.id = data.id;

  //Producto
  formData.defaultAssetId = parseInt(data.defaultAssetId);
  if (!!data.tradeName) {
    formData.tradeName = data.tradeName;
  } else {
    formData.tradeName = null;
  }

  if (!!data.isPublishable) {
    formData.isPublishable = data.isPublishable;
  } else {
    formData.isPublishable = false;
  }
  formData.webBookingAvailable = data.webBookingAvailable;
  if (!!data.webBookingAvailableURL) {
    formData.webBookingAvailableURL = data.webBookingAvailableURL;
  } else {
    formData.webBookingAvailableURL = null;
  }
  if (
    data.manualHidePvPAPICRM === "true" ||
    data.manualHidePvPAPICRM === true
  ) {
    formData.manualHidePvPAPICRM = true;
  } else if (
    data.manualHidePvPAPICRM === "false" ||
    data.manualHidePvPAPICRM === false
  ) {
    formData.manualHidePvPAPICRM = false;
  } else {
    formData.manualHidePvPAPICRM = null;
  }
  if (!!data.isBlocked) {
    formData.isBlocked = data.isBlocked;
  } else {
    formData.isBlocked = false;
  }
  if (!data.reasonBlock && data.reasonBlock !== 0) {
    formData.reasonBlock = null;
  } else {
    formData.reasonBlock = Number(data.reasonBlock);
  }
  if (!!data.easyReferenceBusiness) {
    formData.easyReferenceBusiness = data.easyReferenceBusiness;
  } else {
    formData.easyReferenceBusiness = null;
  }
  if (!!data.isForced) {
    formData.isForced = data.isForced;
  } else {
    formData.isForced = false;
  }
  if (!!data.terciaryWebId) {
    formData.terciaryWebId = data.terciaryWebId;
  } else {
    formData.terciaryWebId = null;
  }
  if (!!data.checkGiai) {
    formData.checkGiai = data.checkGiai;
  } else {
    formData.checkGiai = false;
  }
  if (!!data.rental) {
    formData.rental = data.rental;
  } else {
    formData.rental = false;
  }
  if (!!data.rental) {
    formData.rental = data.rental;
  } else {
    formData.rental = false;
  }
  if (!!data.garagesAmount) {
    formData.garagesAmount = parseInt(data.garagesAmount);
  } else {
    formData.garagesAmount = 0;
  }
  if (!!data.storagesAmount) {
    formData.storagesAmount = parseInt(data.storagesAmount);
  } else {
    formData.storagesAmount = 0;
  }

  if (!!data.ignoreMinimalPriceValidation) {
    formData.ignoreMinimalPriceValidation = data.ignoreMinimalPriceValidation;
  } else {
    formData.ignoreMinimalPriceValidation = false;
  }

  formData.bts = data.bts || false;

  formData.btsGroup = data.btsGroup || "";

  formData.espCondCode = data.espCondCode || "";

  formData.espCondCode = data.espCondCode || "";

  formData.onlineSale = data.onlineSale || false;

  formData.probabilitySale6Months =
    Number(data.probabilitySale6Months.toString().replace(",", ".")) || 0;
  formData.probabilitySale12Months =
    Number(data.probabilitySale12Months.toString().replace(",", ".")) || 0;
  formData.estimatedTimeSell = data.estimatedTimeSell || "";

  //Segmentación
  if (!!data.segmentationPrimary) {
    formData.segmentationPrimary = data.segmentationPrimary;
  } else {
    formData.segmentationPrimary = null;
  }
  if (!!data.segmentationSecondary) {
    formData.segmentationSecondary = data.segmentationSecondary;
  } else {
    formData.segmentationSecondary = null;
  }
  if (!!data.segmentationPrimaryType) {
    formData.segmentationPrimaryType = data.segmentationPrimaryType;
  } else {
    formData.segmentationPrimaryType = null;
  }
  if (!!data.segmentationSecondaryType) {
    formData.segmentationSecondaryType = data.segmentationSecondaryType;
  } else {
    formData.segmentationSecondaryType = null;
  }

  //Interes comercial
  if (!!data.commercialInterestScore || data.commercialInterestScore === 0) {
    formData.commercialInterestScore = parseInt(data.commercialInterestScore);
  } else {
    formData.commercialInterestScore = null;
  }
  if (!!data.commercialInterestDescription) {
    formData.commercialInterestDescription = data.commercialInterestDescription;
  } else {
    formData.commercialInterestDescription = null;
  }

  return formData;
};

export const getMetadataParticularProduct = (
  isSuperadmin,
  isAnyAdmin,
  manualHidePvPAPICRMAccess,
  hasRoleCommercialDelegate,
  isBlocked,
  reasonBlockPEP
) => {
  return [
    {
      label: "Producto",
      id: "product",
      collapsable: true,
      metadata: [
        {
          label: "Nombre Comercial",
          name: "tradeName",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Importe",
          name: "price",
          type: "text",
          numberSeparator: true,
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "€",
        },
        {
          label: "Valoración interna",
          name: "internalValuationAmount",
          type: "text",
          numberSeparator: true,
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "€",
          visibleFor: [PORTFOLIOS.TERCEROS],
        },
        {
          label: "PVP Mínimo Aprobado BX",
          name: "isBxMinimalPriceApproved",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Api asignado",
          name: "isApiAssigned",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Publicado",
          name: "isPublishable",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Venta online",
          name: "onlineSale",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Venta Online Exclusiva",
          name: "webBookingAvailable",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "URL Venta online exclusiva",
          name: "webBookingAvailableURL",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Código Condiciones Especiales",
          name: "espCondCode",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Cita virtual",
          name: "virtualDate",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Cálculo Precio web a consultar",
          name: "manualHidePvPAPICRM",
          type: "list",
          typeList: "Normal",
          listName: "hidePVP",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Precio web a consultar",
          name: "hidePvPAPICRM",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Bloqueo Comercial",
          name: "isBlocked",
          type: "checkbox",
          disabled:
            isAnyAdmin || hasRoleCommercialDelegate
              ? disabledFalse
              : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Motivo del bloqueo",
          name: "reasonBlock",
          type: "list",
          typeList: "Normal",
          listName: "reasonBlockList",
          propertyId: "Id",
          propertyName: "translation",
          disabled:
            (isAnyAdmin || hasRoleCommercialDelegate) &&
            isBlocked &&
            !reasonBlockPEP
              ? disabledFalse
              : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
          required: false,
        },
        {
          label: "Referencia Negocio Fácil",
          name: "easyReferenceBusiness",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado del producto",
          name: "status",
          type: "textFromList",
          typeList: "Normal",
          listName: "productStatus",
          propertyList: "translation",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Disponible",
          name: "isAvailable",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Comentarios del Estado",
          name: "comments",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Id Web Terciario",
          name: "terciaryWebId",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Check GIAI",
          name: "checkGiai",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Alquiler",
          name: "rental",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Superficie total",
          name: "builtM2Product",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² publicables",
          name: "areaPublishable",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
          tooltip:
            "La superficie publicable es el resultado de un algoritmo acordado con BX y Anticipa que se basa en la superficie construida de catastro, pudiendo repercutir en algunos casos zonas comunes. En general no coincide con la superficie que aparece en la nota simple.",
        },
        {
          label: "Número de garajes",
          name: "garagesAmount",
          type: "text",
          min: 0,
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de trasteros",
          name: "storagesAmount",
          type: "text",
          min: 0,
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Ignorar validez precio mínimo",
          name: "ignoreMinimalPriceValidation",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Susceptible BTS",
          name: "bts",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Agrupación OSS",
          name: "btsGroup",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Probabilidad de venta a 6 meses",
          name: "probabilitySale6Months",
          type: "text",
          hidden: hiddenFilter,
          disabled: disabledFalse,
          languageSensitive: false,
          addon: "%",
        },
        {
          label: "Probabilidad de venta a 12 meses",
          name: "probabilitySale12Months",
          type: "text",
          hidden: hiddenFilter,
          disabled: disabledFalse,
          languageSensitive: false,
          addon: "%",
        },
        {
          label: "Plazo estimado de venta",
          name: "estimatedTimeSell",
          type: "list",
          typeList: "Normal",
          listName: "estimatedTimeSellOptions",
          propertyId: "id",
          propertyName: "value",
          hidden: hiddenFilter,
          disabled: disabledFalse,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Interés comercial",
      id: "commercialInterest",
      collapsable: true,
      metadata: [
        {
          label: "Interés comercial",
          name: "commercialInterestScore",
          type: "list",
          typeList: "Normal",
          listName: "commercialInterestScore",
          propertyId: "Id",
          propertyName: "name",
          disabled:
            isSuperadmin || hasRoleCommercialDelegate
              ? disabledFalse
              : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Valoración comercial",
          name: "commercialInterestDescription",
          type: "text",
          disabled:
            isSuperadmin || hasRoleCommercialDelegate
              ? disabledFalse
              : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Imágenes",
      id: "images",
      collapsable: true,
      metadata: [
        {
          label: "Imágenes",
          name: "urlImages",
          type: "carousel",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de fotos",
          name: "defaultAssetPhotosNumber",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Letras de las fotos",
          name: "defaultAssetPhotoLetters",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fecha modificación fotos",
          name: "lastPhotosModificationDate",
          type: "dateWithoutMinutes",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Auditoría",
      id: "audit",
      collapsable: true,
      metadata: [
        {
          label: "Fecha Creación",
          name: "creationTime",
          type: "date",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Usuario Creación",
          name: "creatorId",
          type: "textFromList",
          typeList: "Normal",
          listName: "users",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fecha Última Modificación",
          name: "lastModificationTime",
          type: "date",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Usuario Modificación",
          name: "lastModifierId",
          type: "textFromList",
          typeList: "Normal",
          listName: "users",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fecha Borrado",
          name: "deletionTime",
          type: "date",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Usuario Borrado",
          name: "deleterId",
          type: "textFromList",
          typeList: "Normal",
          listName: "users",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
  ];
};
